import type { Episode } from "@/types/video";

interface EpisodeSelectorProps {
  episodes: Episode[];
  activeId: number;
  onSelect: (episode: Episode) => void;
}

export default function EpisodeSelector({ episodes, activeId, onSelect }: EpisodeSelectorProps) {
  if (episodes.length === 0) {
    return (
      <div className="rounded-lg border border-background-200/70 bg-background-100 p-4 text-sm text-foreground-600">
        本片为单片资源，暂无可切换的剧集。
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-background-200/70 bg-background-100 p-4">
      <div className="mb-3 flex items-center gap-2">
        <i className="ri-list-check-2 text-primary-500"></i>
        <h3 className="text-sm font-semibold text-foreground-950">选集播放</h3>
        <span className="text-xs text-foreground-500">共 {episodes.length} 集</span>
      </div>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4">
        {episodes.map((ep) => (
          <button
            key={ep.id}
            type="button"
            onClick={() => onSelect(ep)}
            className={`flex cursor-pointer items-center justify-between gap-2 rounded-md border px-3 py-2 text-left text-xs transition ${
              ep.id === activeId
                ? "border-primary-500 bg-primary-100/80 text-primary-900"
                : "border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-400"
            }`}
          >
            <span className="truncate">{ep.title}</span>
            <span className="flex-none text-[10px] text-foreground-500">{ep.duration}</span>
          </button>
        ))}
      </div>
    </div>
  );
}